/**
 * The *Spis k dátumu* banner of a case's surface, shown while a day is set; it clears the day.
 */
import { AsOfBanner } from '@/components/case-as-of/AsOfBanner'
import { useCaseAsOf } from './CaseAsOf'

export function CaseAsOfBanner({ className }: { className?: string }) {
  const { day, setDay } = useCaseAsOf()
  if (!day) return null
  return <AsOfBanner day={day} onClear={() => setDay(null)} className={className} />
}
